import createAction from 'loankeeper-common/helpers/createAction'

import { actions } from './constants'

export const fetchOfficers = (params) => createAction(actions.FETCH_OFFICERS, { params })

export const officersFetched = (officers) => createAction(actions.FETCH_OFFICERS_SUCCESS, { officers })

export const officersFetchFailed = () => createAction(actions.FETCH_OFFICERS_FAILURE)

export const submit = (params, meta) => createAction(actions.SUBMIT, { params }, meta)

export const submitFail = (error) => createAction(actions.SUBMIT_FAIL, { error })

export const close = () => createAction(actions.CLOSE)
